
import { DomainChekcer, School, SubpathChekcer } from '@/models/academy.types';
import { debounce } from 'lodash';
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';

@Component
export default class CheckSchoolName extends Vue {
  // ACTION
  @Action('actionCheckSubpath', { namespace: 'academy' })
  private actionCheckSubpath: any;
  @Action('actionCheckDomain', { namespace: 'academy' })
  private actionCheckDomain: any;

  // STATE
  @State('school_portal')
  private school_portal: string;
  @State('school_portal_domain')
  private school_portal_domain: string;
  @State('school', { namespace: 'academy' })
  private school: School;
  @State('subpath_checker', { namespace: 'academy'})
  private subpath_checker: SubpathChekcer;
  @State('domain_checker', { namespace: 'academy'})
  private domain_checker: DomainChekcer;


  // WATCH
  @Watch('school.subdomain')
  private onChangeDomain(subdomain: string) {
    if (subdomain !== null) {
      localStorage.setItem('subdomain', subdomain);
    }
  }

  /* INITIALIZATION */

  // LIFECYCLE
  private created() {
    const subdomain = localStorage.getItem('subdomain');
    if (subdomain !== null) {
      this.$store.state.academy.school.subdomain = subdomain;
    }
  }

  // METHOD

  // LISTENER
  private listenerSubpathChecker(event: Event) {
    if (this.school.subpath) {
      this.school.subpath = this.school.subpath.replace(/\W+/g, '');
      this.school.subpath = (this.school.subpath as string).toLowerCase();
      this.actionCheckSubpath();
    } else {
      this.subpath_checker.is_valid = false;
    }
  }

  private listenerDomainChecker(event: Event) {
    if (this.school.subdomain) {
      this.school.subdomain = this.school.subdomain.replace(/\W+/g, '');
      this.school.subdomain = (this.school.subdomain as string).toLowerCase();
      this.actionCheckDomain();
    } else {
      this.domain_checker.is_valid = false;
    }
  }

  private debounceCheckSubpath = debounce(
    (event: Event) => {
      this.listenerSubpathChecker(event);
    },
    500,
  );

  private debounceCheckDomain = debounce(
    (event: Event) => {
      this.listenerDomainChecker(event);
    },
    500,
  );
}
